/**
 * Codemade OÜ
 *
 * Application internal state
 * Used https://vuex.vuejs.org/guide/structure.html as template
 *
 * @summary Application internal state
 * @author Borka Martin Orlov
 *
 * Created at     : 2020-08-11 20:52:20
 * Last modified  : 2021-03-28 11:27:52
 */

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import deals from './modules/deals';

export default {
    // Default state
    state,

    // Getters which simplify data retrieving
    getters,

    // State mutations
    mutations,

    // Asynchronous logic
	actions,

	// Modules
	modules: {
        deals,
    },
};
